import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static values = {
    mode: String,
    moveUrl: String,
    reorderUrl: String,
    viewUrl: String,
  }

  connect() {
    this.sortables = []
    let group
    if (this.modeValue === "phase") {
      group = "roadmap-phase"
    } else if (this.modeValue === "month") {
      group = "roadmap-month"
    } else {
      group = "roadmap-board"
    }

    this.element.querySelectorAll("[data-roadmap-column]").forEach((column) => {
      this.sortables.push(
        Sortable.create(column, {
          group,
          animation: 150,
          draggable: ".roadmap-card",
          handle: ".roadmap-card-handle",
          onEnd: (event) => this.persist(event),
        }),
      )
    })
  }

  disconnect() {
    this.sortables.forEach((sortable) => sortable.destroy())
  }

  async persist(event) {
    const itemId = event.item.dataset.itemId
    const position = event.newIndex
    const sameColumn = event.from === event.to
    let reorderScope
    if (this.modeValue === "phase" || this.modeValue === "month") {
      reorderScope = "phase"
    } else {
      reorderScope = "status"
    }

    try {
      if (!sameColumn) {
        const url = this.moveUrlValue.replace(":id", itemId)
        let body
        if (this.modeValue === "phase") {
          body = { phase_id: event.to.dataset.phaseId, position }
        } else if (this.modeValue === "month") {
          body = { target_month: event.to.dataset.targetMonth, position }
        } else {
          body = { status: event.to.dataset.status, position }
        }

        const response = await fetch(url, {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": this.csrfToken,
            Accept: "text/vnd.turbo-stream.html",
          },
          body: JSON.stringify(body),
        })

        if (response.status === 409) {
          const payload = await response.json()
          if (window.confirm(`${payload.warning}\n\nMove anyway?`)) {
            const retry = await fetch(url, {
              method: "PATCH",
              headers: {
                "Content-Type": "application/json",
                "X-CSRF-Token": this.csrfToken,
                Accept: "text/vnd.turbo-stream.html",
              },
              body: JSON.stringify({ ...body, force: true }),
            })
            await this.handleMoveResponse(retry, event)
          } else {
            this.refreshView()
          }
          return
        }

        await this.handleMoveResponse(response, event)
      }

      const ids = [...event.to.children].map((child) => child.dataset.itemId)
      await fetch(this.reorderUrlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": this.csrfToken,
        },
        body: JSON.stringify({ scope: reorderScope, ids }),
      })
    } catch (error) {
      if (error.name !== "AbortError") throw error
    }
  }

  async handleMoveResponse(response, event) {
    if ((this.modeValue === "phase" || this.modeValue === "month") && event.from !== event.to) {
      this.refreshView()
      return
    }

    const html = await response.text()
    if (html) Turbo.renderStreamMessage(html)
  }

  refreshView() {
    if (!this.hasViewUrlValue) return

    const frame = document.getElementById("roadmap_view")
    if (frame) frame.src = this.viewUrlValue
  }

  get csrfToken() {
    return document.querySelector("meta[name='csrf-token']")?.content
  }
}
